import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NpsScoreService {
  // Function to calculate NPS score for either current or previous data
  calculateCategoryAndOverallScore(score: { detractors: number; promoters: number; passives: number }): number {
    const detractors = Number(score.detractors);
    const passives = Number(score.passives);
    const promoters = Number(score.promoters);
    const totalScores = detractors + passives + promoters;

    if (isNaN(totalScores) || totalScores === 0) {
      return 0;
    }

    const promoterScore = promoters / totalScores;
    const detractorScore = detractors / totalScores;
    const overallScore = promoterScore - detractorScore;

    return isNaN(overallScore) ? 0 : Math.round(overallScore * 100);
  }
}
